<div class="popup-wrapper">
  <div class="container">
    <div class="top-buttons">
      <div class="align-left">
        <ng-container *ngIf="actions?.length > 0">
          <button
            *ngFor="let action of actions"
            mat-stroked-button
            color="secondary"
            class="action-btn"
            tabindex="-1"
            [ngClass]="{ 'btn-active': action.isActive && action.isActive() }"
            (click)="action.action()"
          >
            <mat-icon
              *ngIf="action.icon"
              [ngStyle]="{ color: action.iconColor }"
              >{{ action.icon }}</mat-icon
            >
          </button>
        </ng-container>
      </div>
      <div class="align-right">
        <button
          mat-stroked-button
          color="secondary"
          class="action-btn"
          (click)="save()"
        >
          <mat-icon class="save">save</mat-icon>
        </button>
        <button
          mat-stroked-button
          color="warn"
          class="action-btn"
          (click)="close()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <textarea class="textBox" [(ngModel)]="textValue"></textarea>
  </div>
</div>
